import React from "react";

export default function DashboardCard({ data = [] }) {
  // data = [{ title: "", icon: "", iconBg: "",data:'' }]
  return (
    <>
      <div className="grid lg:grid-cols-4 gap-1 grid-cols-2 md:grid-cols-3 text-center">
        {data.map((item, i) => (
          <div key={`card_DB_${i}`}>
            <div className="bg-white border rounded shadow p-2">
              <div className="flex flex-row items-center">
                <div className="flex-shrink pr-4">
                  <div
                    className={`rounded p-2 ${
                      item.iconBg === undefined || item.iconBg === ""
                        ? "bg-green-600"
                        : item.iconBg
                    }`}
                  >
                    <i
                      className={`fa fa-${
                        item.icon === undefined || item.icon === ""
                          ? "user"
                          : item.icon
                      } fa-2x fa-fw fa-inverse`}
                    />
                  </div>
                </div>
                <div className="flex-1 text-right md:text-center">
                  <h6 className="font-bold uppercase text-gray-500 text-sm">
                    {item.title}
                  </h6>
                  <h3 className="font-bold text-3xl">
                    {item.data}
                    <span className="text-green-500"></span>
                  </h3>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <hr className="border-b-2 border-gray-400 my-8 mx-4" />
    </>
  );
}
